import { render, staticRenderFns } from "./select-item-supplier-form.vue?vue&type=template&id=5b50ac66&scoped=true&"
import script from "./select-item-supplier-form.vue?vue&type=script&lang=js&"
export * from "./select-item-supplier-form.vue?vue&type=script&lang=js&"
import style0 from "./select-item-supplier-form.vue?vue&type=style&index=0&id=5b50ac66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b50ac66",
  null
  
)

export default component.exports